import {
	updateNavbarIsSticky,
	updateNavbarIsTransparent,
	updateNavbarType,
} from '../../../../../../../store/actions/admin/create-event';
import { addChecklistItem } from '../../../../../../../store/actions/authentication';
import { ChecklistTitles } from '../../../../../../../store/reducers/admin/assistant';
import { useAppDispatch, useTypedSelector } from '../../../../../../../store/reducers/use-typed-selector';
import { ENavbarTypes } from "../../../../../../../types/working-model";

export enum EHeaderModalTabs {
	layout = 'Layout',
	menu = 'Menu'
}

type TUseOnSave = (params: {
	activeTab: EHeaderModalTabs,
	navPosition?: ENavbarTypes,
	isSticky: boolean,
	isTransparent: boolean,
	closeModal: () => void
}) => () => void;

export const useOnSave: TUseOnSave = ({ activeTab, navPosition, isSticky, isTransparent, closeModal }) => {
	const dispatch = useAppDispatch();
	const token = useTypedSelector(state => state.AuthReducer.token);
	const user = useTypedSelector(state => state.AuthReducer.user);
	
	const isSideNavbar = navPosition === ENavbarTypes.Vertical;
	const handleSetNavbarType = (navbarType: ENavbarTypes): void => {
		dispatch(updateNavbarType(navbarType));
	};
	
	const handleSetIsSticky = (isSticky: boolean): void => {
		dispatch(updateNavbarIsSticky(isSticky));
	};
	
	const handleSetIsTransparent = (isTransparent: boolean): void => {
		dispatch(updateNavbarIsTransparent(isTransparent));
	};
	
	return () => {
		if (!token) return;
		
		if (user && !user.onboarded.includes(ChecklistTitles.editNavigationBar)) {
			dispatch(addChecklistItem(token, user.id, user.onboarded, ChecklistTitles.editNavigationBar));
		}
		
		if (activeTab === EHeaderModalTabs.layout && navPosition) {
			handleSetNavbarType(navPosition);
		}
		
		if (isSideNavbar) {
			handleSetIsSticky(false);
			handleSetIsTransparent(false);
			closeModal();
			
			return;
		}
		
		handleSetIsSticky(isSticky);
		handleSetIsTransparent(isTransparent);
		closeModal();
	};
};